import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import {settings} from '../config/config'
import TweetButton from '../components/tweetbutton'

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  icon: {
    marginRight: theme.spacing.unit * 2,
  },
  heroUnit: {
    margin: "0 0 15px 0"
  },
  heroContent: {
    maxWidth: 600,
    margin: '0 auto',
    padding: `${theme.spacing.unit * 8}px 0 ${theme.spacing.unit * 6}px`,
  },
  heroButtons: {
    marginTop: theme.spacing.unit * 4,
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
      width: 1100,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  root: {
    flexGrow: 1,
  },
  typography: {
    paddingLeft: theme.spacing.unit * 2,
    backgroundColor: theme.palette.background.paper,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    color: theme.palette.text.secondary,
  },
  image: {
    maxWidth: "100%",
    width: "480px",
    display: "block"
  }
});

class Index extends Component{

  render(){
    const { classes } = this.props;

    return(<main>
      <div className={classes.heroUnit}>
        <div className={classes.heroContent}>
            <Typography component="h4" variant="h4" align="center" gutterBottom>
              クソリプバスター
            </Typography>
            <Typography component="h6" variant="h6" align="center" gutterBottom>
              Twitterのブロック効率化
            </Typography>
          <div className={classes.heroButtons}>
            <Grid container justify="center">
              <Grid item>
                <a href={settings.url + "/auth"} style={{textDecoration:"none"}}>
                  <Button variant="contained" color="primary">
                    Twitterと連携して使用する
                  </Button>
                </a>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
      <Grid container>
        <Grid item xs={12}>
          <Typography component="h5" variant="h5" className={classes.typography}>
            サーバー移転のお知らせ
          </Typography>
          <Paper className={classes.paper}>
          2020年6月26日をもってクソリプバスターを運用しているサーバーを移転しました。<br/>
          これに伴い、同日以前に生成されたCSVはご利用いただけなくなります。<br/>
          蓄積されたユーザーデータについてもリセット対象となっていますので、なにとぞご承知おきください。<br/>
          本サービスは無償で運営されております。もしお気に召していただけた場合、<a href="https://www.amazon.co.jp/dp/B06X982RQ9/">こちら</a>からmsqkn310@gmail.com宛にAmazonギフト券でご支援を頂けると大変励みになります。よろしくお願いいたします。
          </Paper>
          <Typography component="h5" variant="h5" className={classes.typography}>
            Twitterの新UIに関して
          </Typography>
          <Paper className={classes.paper}>
            現在、Twitter Webの新UIが順次ユーザーに提供されています。<br/>
            <a href="https://help.twitter.com/en/using-twitter/advanced-twitter-block-options" target="_blank" rel="noreferrer noopener">新UIに於いてはブロックリストインポートができない</a>ため、旧UIに戻さなければ本サイトで作成したCSVを活用することができません。<br/>
            戻し方については複数の手法がありますが、UA偽装に依った方法が最も簡単であると思います。<br/>
            Google Chromeをお使いの方は<a href="https://chrome.google.com/webstore/detail/goodtwitter/jbanhionoclikdjnjlcmefiofgjimgca" target="_blank" rel="noreferrer noopener">こちら</a>を、
            Firefoxをお使いの方は<a href="https://addons.mozilla.org/ja/firefox/addon/goodtwitter/" target="_blank" rel="noreferrer noopener">こちら</a>をクリックして、当該手法を簡単に使用することができる
            拡張機能(GoodTwitter)を導入することができます。ぜひお試しください。
          </Paper>
          <Typography component="h5" variant="h5" className={classes.typography}>
            このサイトについて
          </Typography>
          <Paper className={classes.paper}>
            特定ユーザーのフォロワー一覧、特定ツイートに対してツイートしている人間一覧、特定文字を含むツイートをしている人間一覧をTwitterのブロックリストインポート機能で取り込める形でダウンロードできるツールです。<br/>
            このツールは、「クソリプを送る人間をフォローしているような奴はどうせ全員そいつと似たりよったりな人間だろう、だからまとめてブロックしてしまえ」というスタンスのもと作成されました。
          </Paper>
          <Typography component="h5" variant="h5" className={classes.typography}>
            サイトの特徴
          </Typography>
          <Paper className={classes.paper}>
            <p>
              ・過去に作成したブロックリストを遡ってダウンロードできます<br/>
              ・サイトに登録している他のユーザーが作成したブロックリストを閲覧・保存できます<br/>
              ・他のユーザーとブロック数を統計比較できます
            </p>
          </Paper>
          <Typography component="h5" variant="h5" className={classes.typography}>
              簡単な使い方
          </Typography>
          <Paper className={classes.paper}>
            <Typography component="h6" variant="h6" className={classes.typography}>
                CSV取得
            </Typography>
            <p style={{paddingLeft:"16px"}}>
              <img className={classes.image} src="https://files.poyashi.me/img1.jpg" alt="Download CSV" />
              サイト内に表示されている手順に従い、取得したいユーザーリストのCSVをダウンロードしてください。<br/>
              検索対象文字列・検索範囲などの条件を入力後「ダウンロード」ボタンをクリックすることで、ユーザーリストが取得・表示されます。<br/>
              リスト一覧の左列のダウンロードボタンをクリックすることで、各CSVをダウンロードできます。
            </p>
            <Typography component="h6" variant="h6" className={classes.typography}>
                インポート
            </Typography>
            <p style={{paddingLeft:"16px"}}>
              <img className={classes.image} src="https://files.poyashi.me/img2.jpg" alt="Twitter settings" />
              Twitterの設定画面より、<a href="https://twitter.com/settings/blocked" target="_blank" rel="noopener noreferrer">「ブロックしているアカウント」</a>を開きます。<br/>
              「詳細設定オプション」、「リストをインポート」の順にクリックしてください。<br/>
              あとは画面の指示通りに進めるだけで、CSVに登録されているユーザーを一括でブロックすることができます！
            </p>
          </Paper>
          <Typography component="h5" variant="h5" className={classes.typography}>
            権限関連
          </Typography>
          <Paper className={classes.paper}>
            <strong>このツールが要求するアクセス権限のレベルは「Read only」です。</strong><br/>
            この権限に関する情報は「<a href="https://developer.twitter.com/en/docs/basics/authentication/overview/application-permission-model">Application permission model - Twitter Developers</a>」を参照してください。<br/>
            このツールがあなたのアカウントを使って勝手につぶやいたり、プロフィールを編集する方法はありません。
          </Paper>
          <Typography component="h5" variant="h5" className={classes.typography}>
            お問い合わせ先
          </Typography>
          <Paper className={classes.paper}>
            このツールに関する質問、要望、苦情などに関しては<a href="https://twitter.com/10swanderer">@10swanderer</a>で承ります。<br/>
            Twitterでブロックされている場合、Discord、メールでも対応可能です。<br/>
            Discord: hori#5952 , メール : msqkn310@gmail.com<br/>
            割とサーバーの容量がしんどいので半年以上前とかのCSVは削除しています。
          </Paper>
          <TweetButton/>
        </Grid>
      </Grid>
    </main>)
  }
}

Index.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Index);
